import { Text } from "@/atoms"

export const NullCharacterCommandLine = () => <Text>{" \\ "}</Text>
